<template>
  <div class="container-fluid mt-2">
    <h2>Inventuren</h2>
    <div role="toolbar" class="btn-toolbar justify-content-between">
      <div class="btn-group">
        <button class="btn btn-secondary" @click="prevPage()" id="prev"><font-awesome-icon icon="chevron-left"/></button>
        <button class="btn btn-secondary" @click="nextPage()" id="next"><font-awesome-icon icon="chevron-right"/></button>
      </div>
      <div class="input-group">
        <div class="input-group-prepend">
          <button class="btn btn-secondary"><font-awesome-icon icon="search"/></button>
        </div>
        <input class="form-control" @keyup="updateSearch()" id="search" v-model="search" type="text"/>
      </div>
    </div>
    <b-table class="mt-3" striped hover :fields="fields" :items="rows">
      <template v-slot:cell(deliverDate)="data">
        {{ data.item.deliverdate }}
      </template>
    </b-table>
  </div>
</template>

<script>
import inventories from '@/modules/inventories.js'

export default {
  name: 'InventoryList',
  props:['customer'],
  data() {
    return {
      search: "",
      rows: [],
      fields: [
        {label:"Inventur-Nr",key:"map_id"},
        {label:"Kunde-Nr",key:"customer.map_id"},
        {label:"Kunde",key:"customer.title"},
        {label:"Erstellt",key:"created"},
        {label:"Status",key:"status"},
      ]
    }
  },
  created: function() {
    this.fetchData();
  },
  methods: {
    fetchData: function() {
      var self = this;
      inventories.list(function(data) {
        self.rows = data.rows;
      })
    },
    updateSearch: function() {
      inventories.viewparams.search = this.search;
      this.fetchData();
    },
    prevPage: function() {
      if (inventories.viewparams.page > 1) {
        inventories.viewparams.page--;
        this.fetchData();
      }
    },
    nextPage: function() {
      if (this.rows.length > 0) {
        inventories.viewparams.page++;
        this.fetchData();
      }
    }
  }
}
</script>
